import { token } from '@atlaskit/tokens';
import styled from 'styled-components';
import * as grid from 'view/styles/grid';

export const EditorWrapper = styled.div`
    .akEditor {
        /**
         * This is needed to prevent editor's table controls (+/x) to add/delete row,
         * getting partially hidden behind the text area.
         * We do not need the margin values of 'less-margin' class, which is defined here - https://bitbucket.org/atlassian/atlassian-frontend/src/91b21ecff04a782cf73f24fc8dfdf2bad7d2a904/packages/editor/editor-core/src/ui/Appearance/Comment/Comment.tsx?at=master&atlOrigin=eyJpIjoiMWRiZjlmZjhkYmE3NDg0Mzk3NWI3ODZhZjczNGQyODQiLCJwIjoiYmItY2hhdHMtaW50ZWdyYXRpb24ifQ#lines-217
         * A ticket has been created with editor team for this - https://product-fabric.atlassian.net/browse/DTR-855
         */
        .less-margin .ProseMirror {
            margin: ${token('space.150', '12px')} ${grid.multiple(1.75).px} ${grid.multiple(1.75).px};
        }
    }
`;
